import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import Iframe from 'react-iframe';
import moment from 'moment';
import RaisedButton from 'material-ui/RaisedButton';
import { renderAutoCompleteMultipleSelection, renderDateField } from '../../../../components/reduxFields';
import { GetReportUrl, base64Encode, IS_REPORT_ORGANISED } from '../../../../actions/utilAction';
import Loader from '../../../../img/loader.gif';
import {getMasterData, HasUrlAccess} from '../../actions/index';
import history from '../../../../history';

class FloridaPayrollWithoutMileageAndBreakReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      organizationID: this.props.orgID,
      access_token: this.props.access_token,
      FromDate: new Date().setDate(new Date().getDate() - 7),
      ToDate: new Date(),
      // iframeURL: `${REPORT_URL}?%2fHC.SqlReports%2fPatientAppointmentReport&rs:Command=Render&rs:embed=true&OrganizationID=` + this.props.orgID + '&LocationID=' + this.props.locationID,
      iframeURL: '',
      isLoading: false,
      random: 0,
    };
    this.onDateChange = this.onDateChange.bind(this);
    this.appointmentFilterByDate = this.appointmentFilterByDate.bind(this);
  }
  
  componentWillMount() {    
    this.props.HasUrlAccess('/reports/payroll-florida-withoutmileageandbreak');  
    let masterData = {
      'masterdata': 'MASTERALLSTAFF',
    };    
     this.props.getMasterData(masterData);    
  }
  
    onDateChange = (input, value) => {
      input.onChange(moment(value).format());
      this.setState({
        [input.name]: value,
      });
    }

    appointmentFilterByDate = (formData) => {
      this.resetIframe();

      let FromDateFormat;
      let ToDateFormat;
      let DateFormat;
      let dateFormat;

      if (Object.keys(formData).length) {
        FromDateFormat = moment(this.state.FromDate).format('YYYY-MM-DD');
        ToDateFormat = moment(this.state.ToDate).format('YYYY-MM-DD');
      } else {
        DateFormat = new Date().setDate(new Date().getDate() - 7);
        FromDateFormat = moment(DateFormat).format('YYYY-MM-DD');
        dateFormat = new Date();
        ToDateFormat = moment(dateFormat).format('YYYY-MM-DD');
      }
      let REPORT_URL  = GetReportUrl(this.props.agencyName);  
      // this.setState({
      //   iframeURL: `${REPORT_URL}?Params=[{"Name": "AGENT","Value": "`+ base64Encode(this.state.organizationID.toString()) + `"},{"Name": "FromDate","Value": "`+ FromDateFormat + `"},{"Name": "ToDate","Value": "`+ ToDateFormat + `"},{"Name": "LocationID","Value": "`+ (formData.location || 0) + `"},{"Name": "Offset","Value": "`+ moment().utcOffset() + `"},{"Name": "StaffIds","Value": "0"}]&AccessToken=` + this.state.access_token + `&ReportName=PYR_SUTOSA`,
      // });      
      // console.log('(formData.staffIds ? formData.staffIds : 0).............',(formData.staffIds && formData.staffIds.length > 0 ? formData.staffIds : 0))
      let reportName = base64Encode('Payroll_Florida_MONTOSUN_WithoutMileageAndBreak');
      this.setState({
        isLoading: true,
        iframeURL: `${REPORT_URL}?Params=[{"Name": "AGENT","Value": "`+ base64Encode(this.state.organizationID.toString()) + `"},{"Name": "FromDate","Value": "`+ FromDateFormat + `"},{"Name": "ToDate","Value": "`+ ToDateFormat + `"},{"Name": "LocationID","Value": "`+ (0) + `"},{"Name": "Offset","Value": "`+ moment().utcOffset() + `"},{"Name": "StaffIds","Value": "`+ (formData.staffIds && formData.staffIds.length > 0 ? formData.staffIds : 0) + `"}]&AccessToken=` + this.state.access_token + `&ReportName=` + reportName,        
      });
    }

  handleChange = (input, selectedRecord) => {
    //if (input.name === 'staffIds') {
      input.onChange(selectedRecord);
    //}
    // else{
    //   input.onChange(selectedRecord.value);
    //   this.props.GetStaffByLocation(selectedRecord.value, 'YES')
    // }
  }

  onLoadReport = (e) => {
    this.setState({ isLoading: false});
  }

  resetIframe() {
    this.setState({random: this.state.random + 1});
  }
  
  renderLoading() {
    if (this.state.isLoading) {
      return (
        <div className="full_loader">
          <div className="circle_loader page_loader">
            <img src={Loader} alt="" />
          </div>
        </div>
      );
    }
  }
  onBackClick = () => {
    history.push('/reports/payroll-reports');
  }
  render() {
    const { handleSubmit } = this.props;    
    return (
      <div>
        {this.renderLoading()}
        {IS_REPORT_ORGANISED === 'YES' ?
          <h2 className="page_title">Payroll {' > '} Payroll Report (Sunday To Saturday)</h2>
        :
          <h2 className="page_title">Payroll Report (Sunday To Saturday)</h2>
        } 
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
          {IS_REPORT_ORGANISED === 'YES' &&       
              <div className="modalwindow">
                  <div className="row">
                      <div className="col-sm-2">
                          <RaisedButton label="Back" primary={true} onTouchTap={() => this.onBackClick()} />
                      </div>
                  </div>
              </div>}
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.appointmentFilterByDate)}>
              <div className="row">
                {/* <div className="col-sm-3 mt-35">
                  <Field name="location"
                    label="Location"
                    handleNewRequest={this.handleChange}
                    options={this.props.userLocationList}
                    component={renderAutoCompleteSingleSelect}
                  />
                </div> */}
                <div className="col-sm-4 mt-35">
                  <Field name="staffIds"
                    label="Staff"
                    handleNewRequest={this.handleChange}
                    options={this.props.allStaffs}
                    component={renderAutoCompleteMultipleSelection}
                  />
                </div>                
                <div className="col-sm-3">
                  <Field name="FromDate"
                    placeholder="From Date"
                    locale="en-US"
                    selected={this.state.FromDate}
                    onDateChange={this.onDateChange}
                    openToYearSelection={true}
                    component={renderDateField} />

                </div>
                <div className="col-sm-3">
                  <Field name="ToDate"
                    placeholder="To Date"
                    locale="en-US"
                    // minDate = {this.state.FromDate}
                    selected={this.state.ToDate}
                    openToYearSelection={true}
                    onDateChange={this.onDateChange}
                    component={renderDateField} />
                </div>
                <div className="col-sm-2 btn_lt reset-btn mt-25">
                  <RaisedButton className="grey_btn" type="Submit" primary={true}>Generate</RaisedButton>
                </div>
              </div>
            </form>
          </div>
        </div>
        <Iframe url={this.state.iframeURL}
          // width="450px"
          height="580px"
          id="myId"
          className="manual_report"
          display="initial"
          position="relative"
          onLoad={(e)=> this.onLoadReport(e)}
          key={this.state.random}
          allowFullScreen />
      </div>
    );
  }
}

FloridaPayrollWithoutMileageAndBreakReport = reduxForm({
  form: 'FloridaPayrollWithoutMileageAndBreakReportForm',
})(FloridaPayrollWithoutMileageAndBreakReport);

function mapStateToProps(state) {
  let locationArr = [];

  if (state.login.userLocationList) {
    locationArr = (state.login.userLocationList).map((obj) => {
      return (
        {
          id: obj.id,
          value: obj.locationName,
        }
      );
    });
  }

  // console.log('state.report.staffsByLocation.........',(state.report.staffsByLocation ? state.report.staffsByLocation.data : []))
  return {
    orgID: state.login.loginUserInfo.organizationID,
    userLocationList: locationArr,
    access_token: state.login.access_token,    
    //staffsByLocation : state.report.staffsByLocation ? state.report.staffsByLocation.data : [],
    allStaffs : state.report.master_data ? state.report.master_data.allStaffs : [],
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
  };
}
export default connect(mapStateToProps, {getMasterData, HasUrlAccess})(FloridaPayrollWithoutMileageAndBreakReport);



// WEBPACK FOOTER //
// ./src/modules/Reports/components/PayrollReports/payrollReport_Florida_WithoutMileageAndBreak.js